module.exports = __webpack_public_path__ + "static/img/IMG_20241024_133427.6c15b6a0.jpg";